import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';
import { ErrorBoundary } from 'bernie-view';

import { MultiItemStepIndicator } from '@shared-ui/multi-item-step-indicator';

import { UitkSpacing } from 'uitk-react-spacing';

type StepIndicatorProps = {
  multiItemSessionId: string;
  analytics: AnalyticsStore;
};

export const StepIndicator: React.FunctionComponent<StepIndicatorProps> = ({ multiItemSessionId, analytics }) => {
  const errorCallback = () => {
    analytics.trackEvent('MIT.STEP.INDICATOR.ERROR', 'RFRR Action Event', analytics.omnitureData, null, true);
  };
  const changeLinkCallBack = (rfrr: string, linkName: string, event: React.UIEvent) => {
    analytics.trackEvent(rfrr, linkName, analytics.omnitureData, event, true);
  };

  return (
    <ErrorBoundary label="step-indicator">
      <UitkSpacing padding={{ small: { block: 'three' }, medium: { blockstart: 'one' }, large: { blockstart: 'three' } }}>
        <MultiItemStepIndicator
          inputs={{ multiItemSessionId }}
          showLoadingState={true}
          changeLinkClickCallback={changeLinkCallBack}
          errorCallback={errorCallback}
        />
      </UitkSpacing>
    </ErrorBoundary>
  );
};
